(function () {
  var DISCLAIMER_TEXT =
    'By purchasing, your L-Carnitine ships and bills every 4 weeks';

  function findDisclaimer() {
    var candidates = document.querySelectorAll('.product__rich-text, .rte, p');

    for (var i = 0; i < candidates.length; i++) {
      var text = (candidates[i].textContent || '').trim();

      if (text.indexOf(DISCLAIMER_TEXT) !== -1) {
        // If we matched the <p>, hide its rich-text wrapper if available.
        return candidates[i].closest('.product__rich-text') || candidates[i];
      }
    }

    return null;
  }

  function updateDisclaimer() {
    var disclaimer = findDisclaimer();

    var buyOnce = document.querySelector(
      '.nw-buybox__price-card[data-nw-purchase="onetime"]'
    );

    if (!disclaimer || !buyOnce) return;

    var buyOnceSelected =
      buyOnce.getAttribute('aria-pressed') === 'true' ||
      buyOnce.classList.contains('is-selected');

    disclaimer.style.display = buyOnceSelected ? 'none' : '';
  }

  function start() {
    updateDisclaimer();

    document.addEventListener('click', function (event) {
      if (!event.target.closest('.nw-buybox__price-card')) return;

      setTimeout(updateDisclaimer, 50);
    });

    var observer = new MutationObserver(function () {
      updateDisclaimer();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-pressed', 'class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();